import { render } from "./ExternalLink.vue?vue&type=template&id=167164f2"
import script from "./ExternalLink.vue?vue&type=script&lang=js"
export * from "./ExternalLink.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "167164f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('167164f2', script)) {
    api.reload('167164f2', script)
  }
  
  module.hot.accept("./ExternalLink.vue?vue&type=template&id=167164f2", () => {
    api.rerender('167164f2', render)
  })

}

script.__file = "src/icons/components/filled/ExternalLink.vue"

export default script